module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.to
    }
  }, [_c('i', {
    class: (_vm.iconType + " " + _vm.icon + " " + _vm.iconColorClass + " icon")
  }), _vm._v(" "), _c('span', [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))]
  })], 2)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-192e3754","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/MenuItem.vue
// module id = 1714
// module chunks = 18